export const insertPlaceHolderImage = ({ state }) => {
  return state
    .transform()
    .insertInline({
      type: 'PlaceHolderImage',
      data: {isPlaceHolder: true},
      isVoid: true
    })
    .apply()
}

export const removePlaceHolderImage = ({ state }) => {
  return state
    .transform()
    .deleteBackward(1)
    .apply()
}

export const insertInlineImage = ({ state, src, fileId }) => {
  return state
    .transform()
    .insertInline({
      type: 'image',
      isVoid: true,
      data: { src, fileId }
    })
    .apply()
}

export const updateInlineImage = ({
  state,
  data: { src, title, href, openExternal, maxWidth, fileId }
}) => {
  return state
    .transform()
    .setInline({
      type: 'image',
      isVoid: true,
      data: { src, title, href, openExternal, maxWidth, fileId }
    })
    .apply()
}

export const deleteInlineImage = ({ state }) => {
  return state
    .transform()
    .deleteBackward(1)
    .apply()
}



// WEBPACK FOOTER //
// ./src/components/ImageSlatePlugin/ImageUtils.js